<router-outlet></router-outlet>

<vx-toast-stack />

<!-- default form-field error messages, app-wide -->
<app-form-error-messages />
